// all in terms of seconds
const SECOND = 1;
const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const YEAR = 365 * DAY;
const MONTH = YEAR / 12;

export const TIME = { SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, YEAR };

export const ET_FORMATTER = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    weekday: "long", // 0-6  (needed for weekend test)
    hour: "numeric", // 0-23
    minute: "numeric", // 0-59
    hour12: false
});

export const TIME_IN_DAYS = {
    // purposefully not including MONTH, as it's not a fixed number of days and can lead to unexpected results
    DAY: 1,
    WEEK: 7,
    YEAR: 365
};
